import axios from "axios";
import { apiConfig } from "../services/config";
const actions = {
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit("UPDATE_VERTICAL_NAV_MENU_WIDTH", width);
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit("UPDATE_STARRED_PAGE", payload);
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_LIMITED", list);
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_MORE", list);
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit("TOGGLE_CONTENT_OVERLAY");
  },
  updateTheme({ commit }, val) {
    commit("UPDATE_THEME", val);
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo({ commit }, payload) {
    commit("UPDATE_USER_INFO", payload);
  },

  // Authen template //
  login({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit("AUTH_REQUEST");

      axios({
        url: `${apiConfig}/api/Vendor/Authentication`,
        data: user,
        method: "POST",
      })
        .then((resp) => {
          // console.log("test login", resp.data.data);

          if (resp.data.data.message == undefined) {
            const token = resp.data.data.token;
            const user = resp.data.data;
            const isConsent = resp.data.data.isConsent;

            // console.log(isConsent);

            localStorage.setItem("token", token);
            localStorage.setItem("isConsent", isConsent);
            // Add the following line:
            axios.defaults.headers.common["Authorization"] = token;
            commit("AUTH_SUCCESS", token, user);
            commit("UPDATE_USER_INFO", user);
            resolve(resp);

            // Redirect to home page
            // window.location = "/vendor";

            if (isConsent) {
              // Redirect to home page
              window.location = "/vendor";
            } else {
              window.location = `/vendor/en/consentpdpa`;
            }
          } else {
            commit("AUTH_ERROR", resp.data.data.message);
            resolve(resp);
          }
        })
        .catch((err) => {
          commit("AUTH_ERROR");
          localStorage.removeItem("token");
          reject(err);
        });
    });
  },
  logout({ commit }) {
    // console.log("logout");
    return new Promise((resolve) => {
      commit("AUTH_LOGOUT");
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      delete axios.defaults.headers.common["Authorization"];
      resolve();
    });
  },
  AddLogSelectionAnnouncement({ commit }, value) {
    commit("LOG_SELECTION_ANNOUNCEMENT", value);
  },
  AddLogSelectionCurrentBidding({ commit }, value) {
    commit("LOG_SELECTION_CURRENT_BIDDING", value);
  },
  AddLogSelectionHistoryBidding({ commit }, value) {
    commit("LOG_SELECTION_HISTORY_BIDDING", value);
  },
  // Authen template //
};

export default actions;
